import React from "react";
import {Controller} from 'react-hook-form';
import {useRef} from "react";

export default function ({label, name, control, errorMessage, required = false}) {

  const imageRef = useRef();

  const resetInput = () => {
    if(imageRef?.current?.value){
      imageRef.current.value = null;
    }
  }

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue=''
        render={({field: {onChange, value}}) => (
          <div className="fv-row mt-10">
            <label className="form-label fs-6 fw-bolder text-dark">
              {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
            </label>
            <input onChange={e => onChange(e.target.files[0] || '')}
                   className="form-control upload_product_template my-1"
                   type="file"
                   ref={imageRef}
            />
            {
              !value && resetInput()
            }
            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
}